import axios from 'axios'
import store from '../../store'
// Define base url
const BASE_URL = '/api/v1/cost-codes'

// Define cost_codes module
const cost_codes = {
  state: {
    errors: {}
  },
  getters: {
    costCodesCollection () {
      return store.getters.projectsSingleData === undefined ? [] : store.getters.projectsSingleData.cost_codes
    }
  },
  mutations: {
    setCostCodesErrors (state, payload) {
      state.errors = payload
    }
  },
  actions: {
    async costCodesStore ({ commit }, payload) {
      try {
        const response = await axios.post(BASE_URL, payload)
        if (response.status === 201) {
          return response.data.data
        }
      } catch (error) {
        commit('setCostCodesErrors', error.response.data)
      }
    },
    async costCodesUpdate ({ commit }, payload) {
      try {
        const response = await axios.put(`${BASE_URL}/${payload.id}`, payload)
        if (response.status === 202) {
          return response.data.data
        }
      } catch (error) {
        commit('setCostCodesErrors', error.response.data)
      }
    },
    async costCodesDestroy ({ commit }, payload) {
      try {
        const response = await axios.delete(`${BASE_URL}/${payload.id}`, payload.id)
        if (response.status === 204) {
          commit('deleteCostCodeData', payload)
        }
      } catch (error) {
        Promise.reject(error)
      }
    }
  }
}

// Export the cost_codes module
export default cost_codes
